/**
 * @generated SignedSource<<b0e5729d974eb3f9e8a4d6768d9aeb16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationContactDetails_viewer$data = {
  readonly geographySalesforce: {
    readonly " $fragmentSpreads": FragmentRefs<"Country_geographySalesforce" | "State_geographySalesforce">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationContactDetailsRefetchable_viewer">;
  readonly " $fragmentType": "SellerApplicationContactDetails_viewer";
};
export type SellerApplicationContactDetails_viewer$key = {
  readonly " $data"?: SellerApplicationContactDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationContactDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationContactDetails_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "country",
          "value": ""
        }
      ],
      "kind": "FragmentSpread",
      "name": "SellerApplicationContactDetailsRefetchable_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "contextName",
          "value": "SELLER_APPLICATION"
        }
      ],
      "concreteType": "GeographySalesforce",
      "kind": "LinkedField",
      "name": "geographySalesforce",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "State_geographySalesforce"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Country_geographySalesforce"
        }
      ],
      "storageKey": "geographySalesforce(contextName:\"SELLER_APPLICATION\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f09232c96edad041e448480d09600a11";

export default node;
